export const AI_REVIEW_TERMINAL = new Set(['completed', 'failed', 'cancelled', 'superseded']);

export function isTerminal(status: string): boolean {
  return AI_REVIEW_TERMINAL.has(status);
}

export function statusColor(status: string): string {
  switch (status) {
    case 'completed':
      return 'green';
    case 'failed':
    case 'cancelled':
      return 'red';
    case 'superseded':
      return 'gray';
    default:
      return 'blue';
  }
}

export function statusLabel(status: string): string {
  switch (status) {
    case 'pending':
      return 'Queued';
    case 'in_progress':
      return 'In progress';
    case 'awaiting_result':
      return 'Awaiting result';
    case 'completed':
      return 'Completed';
    case 'failed':
      return 'Failed';
    case 'cancelled':
      return 'Cancelled';
    case 'superseded':
      return 'Superseded';
    default:
      return status;
  }
}

export function prettyClassification(c: string): string {
  return c.replace(/^SKIN_LESION_/, '').replaceAll('_', ' ');
}

export function categoryColor(category: string): string {
  switch (category.toLowerCase()) {
    case 'malignant':
      return 'red';
    case 'premalignant':
    case 'pre-malignant':
      return 'orange';
    case 'benign':
      return 'green';
    default:
      return 'gray';
  }
}
